import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FileSelectEvent, FileUploadModule } from 'primeng/fileupload';
import { TripService } from '../../services/trip.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { UploadConfigService } from '../../../shared/services/upload-config.service';
import { GreentripperPinIconComponent } from '../../../shared/components/greentripper-pin-icon/greentripper-pin-icon.component';

@Component({
  selector: 'app-banner',
  imports: [ButtonModule, FileUploadModule, TranslocoPipe, CommonModule, GreentripperPinIconComponent],
  templateUrl: './banner.component.html',
})
export class BannerComponent {
  private uploadConfig = inject(UploadConfigService);
  fileUploadMaxSize = this.uploadConfig.TRIP_IMAGE.maxSize;
  tripService = inject(TripService);

  onFileChange(event: FileSelectEvent) {
    this.tripService.uploadTripImage(event.files[0]);
  }
}
